"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const useDeepComparisonMemoize_1 = __importDefault(require("./useDeepComparisonMemoize"));
function useDeepComparisonEffect(react, callback, dependencies) {
    react.useEffect(callback, dependencies.map(dep => (0, useDeepComparisonMemoize_1.default)(react, dep)));
}
exports.default = useDeepComparisonEffect;
